import React from 'react'
import PropTypes from 'prop-types'
// import { RadioButton } from 'loyal-react'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const PointsOnly = ({ balance, selectPointsOnly, catalog, paymentSelected, totalPrice }) => {
  const pointsValue = balance.pointsValue
  const totalPoints = totalPrice.points
  return (
    <div className='p-0 payment-item item h-auto col-12 border-color-ui-3 py-0'>
      <div className='d-flex justify-content-between flex-column flex-md-row align-items-start align-items-md-center h-100'>
        <div className={(process.env.REACT_APP_CARD_PRODUCT_MOBILE === 'column' ? ('p-0 col-auto align-items-center') : ('p-0 col-7 align-items-center'))}>
          <div className='d-flex align-items-center h-100'>
            <input
              type='radio'
              id='PointsOnly'
              name='PaymentMethod'
              value='PointsOnly'
              ariaLabelledby='myPointsTxt'
              className='col-auto pl-0'
              role='radio'
              defaultChecked={paymentSelected === 'POINTS_ONLY'}
              onClick={selectPointsOnly}
              disabled={pointsValue < totalPoints}
            />

            <div className='col-11 py-1'>
              <label htmlFor='PointsOnly' className='txt-body-sm' id='myPointsTxt' aria-hidden='false'>
                {`Apenas ${catalog &&
                catalog.currencyConfiguration &&
                catalog.currencyConfiguration.pointsName}`}
              </label>
              {(() => {
                if (pointsValue < totalPoints) {
                  return (
                    <p className='color-error fontSize14 d-block'>
                      Você não tem pontos suficientes pra pagar apenas com pontos.
                    </p>
                  )
                } else {
                  return (
                    null
                  )
                }
              })()}
            </div>
          </div>
        </div>
        <div className='p-0 p-md-2 col-12 col-md-5 txt-right'>
          <p className='d-flex txt-body-sm py-2 py-md-0'>
            <small className='text-has'>{`Seu saldo: `}</small>
            <CatalogCurrencyLabel
              className='price-value d-md-inline-block d-block txt-body-sm text-brand-bold'
              value={balance.pointsValue}
            />
          </p>
        </div>
      </div>
    </div>
  )
}

PointsOnly.propTypes = {
  balance: PropTypes.object.isRequired,
  totalPrice: PropTypes.object,
  selectPointsOnly: PropTypes.func.isRequired,
  catalog: PropTypes.object.isRequired,
  paymentSelected: PropTypes.string
}

export default PointsOnly



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsOnly/PointsOnly.js